<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik Schladming – Bühne, Ton & Licht mieten",
  ogTitle: "Veranstaltungstechnik Schladming – Bühne, Ton & Licht mieten | Mody",
  description: "Professionelle Veranstaltungstechnik in Schladming und der Steiermark: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik.",
  ogDescription: "Professionelle Veranstaltungstechnik in Schladming und der Steiermark: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-schladming",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "City",
    "name": "Schladming"
  },
  "description": "Professionelle Veranstaltungstechnik in Schladming – Bühne, Ton und Licht für Events jeder Größe."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'Kraftvolle PA-Systeme für Indoor- und Outdoor-Events – auch für anspruchsvolle Berglocations optimiert.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Spektakuläre Lichtshows für Events jeder Größe – von stimmungsvoll bis beeindruckend.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Unser StageTruck ist in ca. 40 Minuten einsatzbereit – ideal für Open-Air-Events und Bergfestivals.' }
]

const events = ['Après-Ski-Events', 'Konzerte', 'Firmenfeiern', 'Hochzeiten', 'Vereinsfeste', 'Open-Air-Events', 'Sportevents', 'Stadtfeste', 'Kabarett & Theater']
const places = ['Schladming', 'Haus im Ennstal', 'Ramsau am Dachstein', 'Rohrmoos', 'Pichl', 'Radstadt', 'Flachau', 'Altenmarkt']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="Schladming & Ennstal"
    title="Veranstaltungstechnik Schladming"
    hero-description="Professionelle Bühne, Ton & Licht für Events in Schladming und dem Ennstal – kurze Wege, zuverlässiger Service, top Equipment."
    intro-heading="Euer Partner für Events in Schladming"
    :intro-paragraphs="[
      'Schladming ist eine der bekanntesten Eventregionen Österreichs – von der Ski-WM bis zu Konzerten und Firmenfeiern. Mody Veranstaltungstechnik beliefert die Region seit über 25 Jahren und kennt die Anforderungen an Technik und Logistik in der Bergregion genau.',
      'Unser Lager in Flachau liegt nur wenige Kilometer entfernt – für schnelle Lieferung und persönlichen Service direkt vor Ort.'
    ]"
    offerings-heading="Was wir in Schladming anbieten"
    :offerings="offerings"
    events-heading="Events, die wir in Schladming betreuen"
    :events="events"
    service-heading="Unsere Orte rund um Schladming"
    service-description="Wir betreuen Events in Schladming und der gesamten Ennstal-Region."
    :places="places"
    cta-heading="Jetzt Angebot für euer Schladming-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
